import { render, staticRenderFns } from "./CustomPropertyBottomContent.vue?vue&type=template&id=0518ae84&scoped=true&"
import script from "./CustomPropertyBottomContent.vue?vue&type=script&lang=ts&"
export * from "./CustomPropertyBottomContent.vue?vue&type=script&lang=ts&"
import style0 from "./CustomPropertyBottomContent.vue?vue&type=style&index=0&id=0518ae84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518ae84",
  null
  
)

export default component.exports